var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';
import { MessageType, logEvent } from '../../../../util/EventLog';
import { THEME } from '../../util/Theme';
import { ExclamationCircleTripleCircle } from '../../../SVG';
import Checkbox, { CheckboxVariant } from '../../../tailwind_common/Checkbox';
// NOTE: We may want to create a shared component from this modal
// but for now creating a custom modal for this use case seemed best
// because the styling is very different from the existing modal
var EmergentOutcomeModal = function (_a) {
    var hasEmergentOutcome = _a.hasEmergentOutcome, conversationId = _a.conversationId, complaint = _a.complaint, onEndIntake = _a.onEndIntake;
    var t = useTranslation().t;
    var _b = useState(false), isDismissed = _b[0], setIsDismissed = _b[1];
    var _c = useState(false), providerEvaluated = _c[0], setProviderEvaluated = _c[1];
    var _d = useState(false), showLoadingModal = _d[0], setShowLoadingModal = _d[1];
    useEffect(function () {
        if (hasEmergentOutcome && !isDismissed) {
            logEvent(MessageType.INTAKE_EMERGENCY_DETECTED, {
                conversationId: conversationId,
                complaint: complaint,
            }, { partner: THEME.partner });
        }
    }, [hasEmergentOutcome, isDismissed]);
    var handleOverrideAndContinue = function () {
        logEvent(MessageType.EMERGENCY_OVERRIDDEN, {
            conversationId: conversationId,
            complaint: complaint,
        }, { partner: THEME.partner });
        setIsDismissed(true);
    };
    var handleEndIntake = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    logEvent(MessageType.INTAKE_ENDED_DUE_TO_EMERGENCY, {
                        conversationId: conversationId,
                        complaint: complaint,
                    }, { partner: THEME.partner });
                    setShowLoadingModal(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetch("/intake/conversations/".concat(conversationId, "/summary"), {
                            method: 'GET',
                        })];
                case 2:
                    res = _a.sent();
                    if (!res.ok)
                        throw new Error('Failed to create intake summary');
                    // Redirect to the summary page
                    window.location.href = "/intake/".concat(conversationId, "/summary");
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setShowLoadingModal(false);
                    alert('There was an error creating the intake summary. Please try again.');
                    return [3 /*break*/, 4];
                case 4:
                    onEndIntake();
                    setIsDismissed(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var showModal = hasEmergentOutcome && !isDismissed;
    var toggleProviderEvaluated = function () { return setProviderEvaluated(!providerEvaluated); };
    useEffect(function () {
        console.log('Modal visibility:', { showModal: showModal, hasEmergentOutcome: hasEmergentOutcome, isDismissed: isDismissed });
    }, [showModal, hasEmergentOutcome, isDismissed]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Dialog, { open: showModal, onClose: function () { }, className: "relative z-10" },
            React.createElement(DialogBackdrop, { transition: true, className: "fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in" }),
            React.createElement("div", { className: "fixed inset-0 z-10 w-screen overflow-y-auto" },
                React.createElement("div", { className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" },
                    React.createElement(DialogPanel, { transition: true, className: "relative mx-auto w-full max-w-lg transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95" },
                        React.createElement("div", { className: "sm:flex sm:items-start" },
                            React.createElement("div", { className: "flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:size-10" },
                                React.createElement(ExclamationCircleTripleCircle, null)),
                            React.createElement("div", { className: "mt-3 sm:ml-4 sm:mt-0 sm:text-left" },
                                React.createElement(DialogTitle, { as: "h3", className: "text-base font-semibold leading-6 text-gray-900" }, t('emergentOutcomeModal.title', 'Alert Provider')),
                                React.createElement("div", { className: "mt-2" },
                                    React.createElement("p", { className: "text-sm text-gray-500" }, t('emergentOutcomeModal.description', 'Alert provider to evaluate for a medical emergency immediately.')),
                                    React.createElement("div", { className: "mt-4 inline-flex items-center" },
                                        React.createElement("div", null,
                                            React.createElement(Checkbox, { checked: providerEvaluated, onChange: toggleProviderEvaluated, label: t('emergentOutcomeModal.providerEvaluated', 'A provider evaluated the patient (confirm before proceeding)') || '', labelClassName: "text-sm text-slate-600", className: "p-0", variant: CheckboxVariant.Small })))))),
                        React.createElement("div", { className: "-mx-4 mt-5 sm:-mx-6 sm:mt-6" },
                            React.createElement("div", { className: "h-px w-[calc(100%+2rem)] bg-gray-200 sm:w-[calc(100%+3rem)]" })),
                        React.createElement("div", { className: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse" },
                            React.createElement("button", { type: "button", onClick: handleEndIntake, disabled: !providerEvaluated, tabIndex: 0, className: twMerge('inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto', providerEvaluated
                                    ? 'bg-red-600 hover:bg-red-500'
                                    : 'cursor-not-allowed bg-gray-400') }, t('emergentOutcomeModal.endIntake', 'End Intake')),
                            React.createElement("button", { type: "button", onClick: handleOverrideAndContinue, disabled: !providerEvaluated, tabIndex: 0, className: twMerge('mt-3 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-sm ring-1 ring-inset focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 sm:mt-0 sm:w-auto', providerEvaluated
                                    ? 'bg-white text-gray-900 ring-gray-300 hover:bg-gray-50'
                                    : 'cursor-not-allowed bg-gray-100 text-gray-400 ring-gray-200') }, t('emergentOutcomeModal.overrideAndContinue', 'Override and Continue'))))))),
        showLoadingModal && (React.createElement("div", { className: "fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm" },
            React.createElement("div", { className: "flex min-w-[320px] flex-col items-center rounded-xl bg-white px-8 py-10 shadow-lg" },
                React.createElement("svg", { className: "mb-6 h-10 w-10 animate-spin text-blue-800", viewBox: "0 0 24 24", fill: "none" },
                    React.createElement("circle", { className: "opacity-20", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4", fill: "none" }),
                    React.createElement("circle", { className: "opacity-80", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4", strokeLinecap: "round", fill: "none", strokeDasharray: "60", strokeDashoffset: "20" })),
                React.createElement("div", { className: "text-lg font-medium text-gray-800" }, t('emergentOutcomeModal.creatingSummary', 'Creating intake summary report...')))))));
};
export default EmergentOutcomeModal;
